// import React from "@types/react";

import SectionHandler from "./SectionHandler";
import React from "react";
import {ActionPageCreate, StatePageCreate} from "../PageCreate";

class CheckoutSection extends SectionHandler {

    nextHandler() {
        return null;
    }

    checkout = () => {
        let body = {
            name: this.state.name,
            subdomain: this.subdomain(),
            image_uuid: this.state.imageUuid,
            caption: this.state.caption,
            generated_key: this.state.generatedKey
        }
        this.state.pageCreator.post(body, (json) => {
            window.location = json.version_url;
        });
    }

    handle() {
        return <>
            <div className="row my-1">
                <div className="col-md-12 text-center">
                    Are you ready to create your page?
                </div>
            </div>
            { this.state.pageCreator.hasErrors() && <>
                <div className="row my-2">
                    <div className="md-12 text-center alert alert-danger">
                        <p>
                            Please edit this page and try again.
                        </p>
                        {this.state.pageCreator.errors().map((error) => {
                            return <>{`• ${error}`}<br/></>
                        })}
                    </div>
                </div>
            </>}
            <div className="row my-3">
                <div className="md-12 text-center">
                    <button className={"btn btn-primary btn-lg"} disabled={this.state.pageCreator.isInProgress()}
                            onClick={() => {
                                this.checkout()
                            }}>
                        Confirm
                    </button>
                </div>
            </div>
        </>
    }
};

export default CheckoutSection;
